var _desc, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoReel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Video-Player-Slider--Streamline-Ultimate",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Video Player Slider Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#727272",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.341 9.09184c-0.1421 -0.06652 -0.2981 -0.09772 -0.45479 -0.09093 -0.1567 0.00679 -0.30945 0.05137 -0.44521 0.12993 -0.13247 0.07425 -0.243 0.18214 -0.32043 0.31277S9.00155 9.72299 9 9.87484v4.24896c0.00138 0.1519 0.04278 0.3008 0.12002 0.4316 0.07725 0.1308 0.18762 0.2389 0.31998 0.3134 0.13582 0.0784 0.28855 0.1229 0.44523 0.1297 0.15667 0.0068 0.31267 -0.0243 0.45477 -0.0907l3.987 -1.883c0.1996 -0.0869 0.3694 -0.2302 0.4887 -0.4123 0.1193 -0.182 0.1829 -0.395 0.1829 -0.6127 0 -0.2176 -0.0636 -0.4306 -0.1829 -0.6127 -0.1193 -0.182 -0.2891 -0.3253 -0.4887 -0.4123l-3.986 -1.88296Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#727272",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.279 3h13.442s0.779 0 0.779 0.779v16.442s0 0.779 -0.779 0.779H5.279s-0.779 0 -0.779 -0.779V3.779S4.5 3 5.279 3Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#727272",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.93403 5.25c-0.15654 0.00105 -0.31134 0.03292 -0.45556 0.09379 -0.14422 0.06087 -0.27503 0.14956 -0.38498 0.26099 -0.109944 0.11143 -0.196864 0.24342 -0.255796 0.38845 -0.058932 0.14502 -0.088721 0.30023 -0.087667 0.45677v11.1c-0.001054 0.1565 0.028735 0.3117 0.087667 0.4568 0.058932 0.145 0.145852 0.277 0.255796 0.3884 0.10995 0.1115 0.24076 0.2001 0.38498 0.261 0.14422 0.0609 0.29902 0.0928 0.45556 0.0938",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#727272",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.066 5.25c0.1565 0.00105 0.3113 0.03292 0.4555 0.09379 0.1443 0.06087 0.2751 0.14956 0.385 0.26099 0.11 0.11143 0.1969 0.24342 0.2558 0.38845 0.0589 0.14502 0.0887 0.30023 0.0877 0.45677v11.1c0.001 0.1565 -0.0288 0.3117 -0.0877 0.4568 -0.0589 0.145 -0.1458 0.277 -0.2558 0.3884 -0.1099 0.1115 -0.2407 0.2001 -0.385 0.261 -0.1442 0.0609 -0.299 0.0928 -0.4555 0.0938",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoReel);
export default __webpack_public_path__ + "static/media/video_reel.ef99705a3d8b8a1dba6df86de640c9bf.svg";
export { ForwardRef as ReactComponent };